import moment from "moment";

export const relatorioSinteticoUtils = {
  async gerar() {
    this.$v.$touch();
    if (this.$v.$error) {
      this.$vuetify.goTo(1, { duration: 1000, easing: "easeOutCubic" });
      return;
    }

    this.showSkeleton = true;
    this.form.dataHoraInicio = moment(this.datetimestart).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    this.form.dataHoraFim = moment(this.datetimeend).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    // let dateTimeRange = {...this.dateSelected,...this.timeSelected}

    this.form.dateTimeRange = this.dateTimeRange;
    try{
      await this.obterDadosRelatorio(this.form);
    } catch (error) {
      let key = Object.keys(error.response.data)
      this.text = error.response.data[key[0]]
      this.snackbar = true
    }
    

    if (this.getDadosRelatorio.total > 0) {
      this.respostaVazia = false;
    } else {
      this.respostaVazia = true;
    }
    this.tempoMedioChamada = this.getDadosRelatorio.mediaTempoDeChamada;
    this.tempoMedioAtendimento = this.getDadosRelatorio.mediaTempoDeAtendimento;
    this.tempoMedioEspera = this.getDadosRelatorio.mediaEspera;
    this.tempoMedioAbandono = this.getDadosRelatorio.mediaAbandono;
    this.cardNivelServico = this.getDadosRelatorio.nivelServico;
    this.updateChart(this.getDadosRelatorio);
    this.showRelatorios = true;
    this.showSkeleton = false;
  },
  configuraOptionsGraficoAreaChamadas(data, valores, keys, title) {
    data.atendidas = valores.map((valor) => Number(valor.atendidas));
    data.abandonadas = valores.map((valor) => Number(valor.Abandonadas));
    data.transbordo = valores.map((valor) => Number(valor.timeout));
    console.log(data, valores, keys, title)
    let options = {
      title: {
        text: title,
        align: "left",
        style: {
          fontFamily: "sans-serif",
          fontWeight: "bold",
          fontSize: "23px",
          color: "darkenGray",
        },
      },
      xaxis: {
        type: "category",
        categories: keys,
      },
    };

    if (title == "Ligações por Hora") {
      this.optionsLinePorHora = options;
    } else if (title == "Ligações por Dia do Mês") {
      this.optionsLinePorDia = options;
    }
  },

  configuraOptionsGraficoAreaTempos(data, valores, keys, title) {
    data.tmc = valores.map((valor) =>
      moment.duration(valor.mediaTempoDeChamada).asSeconds()
    );
    data.tma = valores.map((valor) =>
      moment.duration(valor.mediaTempoDeAtendimento).asSeconds()
    );
    data.tme = valores.map((valor) =>
      moment.duration(valor.mediaEspera).asSeconds()
    );
    data.tmab = valores.map((valor) =>
      moment.duration(valor.mediaAbandono).asSeconds()
    );

    let options = {
      colors: ["#42A5F5", "#66BB6A", "#EF5350", "#FF5733"],
      fill: {
        type: "solid",
        opacity: 0.3,
      },
      title: {
        text: title,
        align: "left",
        style: {
          fontFamily: "sans-serif",
          fontWeight: "bold",
          fontSize: "23px",
          color: "darkenGray",
        },
      },
      tooltip: {
        y: {
          formatter: (value) => {
            if (value >= 60) {
              var minutes = Math.floor(value / 60);
              const secs = String(value % 60).padStart(2, "0");
              const hours = String(Math.floor(minutes / 60)).padStart(2, "0");
              minutes = String(minutes % 60).padStart(2, "0");

              return `${hours}:${minutes}:${secs}`;
            } else {
              return moment(value, "ss").format("HH:mm:ss");
            }
          },
        },
      },
      yaxis: {
        labels: {
          formatter: (value) => {
            if (value >= 60) {
              var minutes = Math.floor(value / 60);
              const secs = String(value % 60).padStart(2, "0");
              const hours = String(Math.floor(minutes / 60)).padStart(2, "0");
              minutes = String(minutes % 60).padStart(2, "0");

              return `${hours}:${minutes}:${secs}`;
            } else {
              return moment(value, "ss").format("HH:mm:ss");
            }
          },
        },
      },
      xaxis: {
        type: "category",
        categories: keys,
      },
    };

    if (title == "Tempos por Hora") {
      this.optionsLineTmcPorHora = options;
    } else if (title == "Tempos por Dia do Mês") {
      this.optionsLineTmcPorDia = options;
    }
  },
  nextPage(param) {
    if (param === "hora") {
      if (this.pagePorHora + 1 <= this.numberOfPagesHora) {
        this.pagePorHora += 1;
      }
    } else if (param === "dia") {
      if (this.pagePorDia + 1 <= this.numberOfPagesDia) {
        this.pagePorDia += 1;
      }
    }
  },
  formerPage(param) {
    if (param === "hora") {
      if (this.pagePorHora - 1 >= 1) {
        this.pagePorHora -= 1;
      }
    } else if (param === "dia") {
      if (this.pagePorDia - 1 >= 1) {
        this.pagePorDia -= 1;
      }
    }
  },
  firstPage(param) {
    if (param === "hora") {
      if (this.pagePorHora > 1) {
        this.pagePorHora = 1;
      }
    } else if (param === "dia") {
      if (this.pagePorDia > 1) {
        this.pagePorDia = 1;
      }
    }
  },
  lastPage(param) {
    if (param === "hora") {
      if (this.pagePorHora < this.numberOfPagesHora) {
        this.pagePorHora = this.numberOfPagesHora;
      }
    } else if (param === "dia") {
      if (this.pagePorDia < this.numberOfPagesDia) {
        this.pagePorDia = this.numberOfPagesDia;
      }
    }
  },
  maiorQueFormer(numero){
    var p = numero.split(':'),
        s = 0, m = 1;
    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }
    return s;
  },
  menorQueFormer(numero){
    var p = numero.split(':'),
        s = 0, m = 1;
    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }
    return s;
  },
}
